import { useExperimentsContext } from 'yandex-metrica-ab-react';

export const useExperimentMatch = (experiment: string, variant: string): boolean => {
  const { flags } = useExperimentsContext();
  return typeof flags === 'object' && Array.isArray(flags[experiment]) ? (flags[experiment] as Array<string>).includes(variant) : false;
};
